/// <amd-module name="DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Components/AuthorizeAllPipelinesConfirmationDialog" />
import * as React from "react";
import * as Resources from "DistributedTaskUI/SecurityComponent/Resources";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { TitleSize } from "VSSUI/Header";

export interface IAuthorizeAllPipelinesConfirmationDialogProps {
    primaryOnClick: (restrict: boolean) => void;
    onDismiss: () => void;
}

export class AuthorizeAllPipelinesConfirmationDialog extends VssComponent< IAuthorizeAllPipelinesConfirmationDialogProps, {}> {
    constructor(props: IAuthorizeAllPipelinesConfirmationDialogProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        return (
            <Dialog
                titleProps={{ text: Resources.OpenAccessDialogTitle, size: TitleSize.Large }}
                onDismiss={() => { this.props.onDismiss(); } }
                footerButtonProps={[
                    {
                        text: Resources.OpenAccessDialogCancelButton,
                        onClick: () => {
                            this.props.onDismiss();
                        }
                    },
                    { 
                        text: Resources.OpenAccessDialogConfirmButton, 
                        primary: true,
                        onClick: () => {
                            this.props.primaryOnClick(false);
                        } 
                    }
                ]}
                contentSize={1}
            >
                <div>
                   { Resources.OpenAccessDialogMessage }
                   <br/>
                   <br/>
                   { Resources.OpenAccessDialogWarning }
                </div>
            </Dialog>
        );
    }

}
